import { useState } from 'react';
import {
    FormControl,
    FormHelperText,
    TextField,
    OutlinedInput,
    InputAdornment,
    IconButton,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import InputRequired from './InputRequired';
import TooltipHover from './TooltipHover';
import TooltipClick from './TooltipClick';
import useIsMobile from './hooks/useIsMobile';

const InputField = ({ field, errors, register, hidden, readOnly = false, notRequired = false, tooltip = null }) => {
    const [showPassword, setShowPassword] = useState(false);
    const yearDiff = new Date().getFullYear() - 18;
    const isMobile = useIsMobile();


    const commonInputProps = {
        readOnly,
        ...(field.type === 'date' && { min: '1955-01-01' }),
    };

    const commonSx = {
        // '& .MuiInputBase-root': {
        //     backgroundColor: readOnly ? '#f5f5f5' : 'inherit',
        // },
        backgroundColor: readOnly ? '#f5f5f5' : 'inherit',
        display: hidden ? 'none' : '',
    };

    const showError = !!errors[field.name];
    const errorMessage = errors[field.name]?.message;

    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    const adornment = (
        <InputAdornment position="end">
            <IconButton
                aria-label={showPassword ? 'hide the password' : 'display the password'}
                onClick={togglePasswordVisibility}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
            >
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );

    return (
        <FormControl error={showError} fullWidth>
            <strong>
                {field.label}
                {tooltip && (
                    <>
                        {isMobile ? (
                            <TooltipClick
                                title={tooltip}
                            />
                        ) : (
                            <TooltipHover
                                title={tooltip}
                            />
                        )}
                    </>
                )}
                {(!hidden && !notRequired) && <InputRequired />}
            </strong>

            {field.type === 'password' ? (
                <OutlinedInput
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={adornment}
                    placeholder={field.placeholder}
                    size={field.size}
                    {...register(field.name)}
                    inputProps={commonInputProps}
                    sx={commonSx}
                />
            ) : (
                <TextField
                    type={field.type}
                    placeholder={field.placeholder}
                    size={field.size}
                    {...register(field.name)}
                    inputProps={commonInputProps}
                    sx={commonSx}
                    error={showError}
                    {...(field.type === 'date' && { defaultValue: `${yearDiff}-01-01` })}
                />
            )}

            {showError && <FormHelperText>{errorMessage}</FormHelperText>}
        </FormControl>
    );
};

export default InputField;